/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Verdict_TitleInputs */

const en_pc_cmp_verdict_title = /** @type {(inputs: Pc_Cmp_Verdict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our verdict`)
};

const zh_pc_cmp_verdict_title = /** @type {(inputs: Pc_Cmp_Verdict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的结论`)
};

/**
* | output |
* | --- |
* | "Our verdict" |
*
* @param {Pc_Cmp_Verdict_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_verdict_title = /** @type {((inputs?: Pc_Cmp_Verdict_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Verdict_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_verdict_title(inputs)
	return zh_pc_cmp_verdict_title(inputs)
});
export { pc_cmp_verdict_title as "pc.cmp.verdict_title" }